module.exports = __webpack_public_path__ + "static/media/home.a781e53d.svg";